import { render } from "./AposAreaExpandedMenu.vue?vue&type=template&id=30ff5088&scoped=true"
import script from "./AposAreaExpandedMenu.vue?vue&type=script&lang=js"
export * from "./AposAreaExpandedMenu.vue?vue&type=script&lang=js"

import "./AposAreaExpandedMenu.vue?vue&type=style&index=0&id=30ff5088&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ff5088"],['__file',"area/ui/apos/components/AposAreaExpandedMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30ff5088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30ff5088', __exports__)) {
    api.reload('30ff5088', __exports__)
  }
  
  module.hot.accept("./AposAreaExpandedMenu.vue?vue&type=template&id=30ff5088&scoped=true", () => {
    api.rerender('30ff5088', render)
  })

}


export default __exports__